import { format } from "date-fns";

import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, styled, tableCellClasses } from "@mui/material";

import { useState } from "react";
import { InformesInvestigador } from "../../interfaces/ITINERARIO/InformesInvestigador";
import { DateToString } from "../../interfaces/UTILS/FechaFormatear";

interface Props {
    informe: InformesInvestigador,
    rowsPerPage?: Array<number>,
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        zIndex: 0,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        zIndex: -1,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export const TablaInformePendiente: React.FC<Props> = ({ informe, rowsPerPage = [5, 10] }) => {
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(rowsPerPage[0]);

    const columnas = [
        { id: 'et1', label: 'Proyecto', minWidth: 100 },
        { id: 'et2', label: 'Año', minWidth: 50 },
        { id: 'et3', label: 'Fecha Entrega', minWidth: 70 },
        { id: 'et4', label: 'Acción', minWidth: 50 }
    ];

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPerPage(+event.target.value);
        setPage(0);
    };

    const IrAInforme = (idProyecto: number) => {
        const link = 'https://gestionproyectos.espol.edu.ec/Planificacion/Informes/' + idProyecto;
        window.open(link, '_blank');
    }

    const rowsToDisplay = informe.informes.slice(page * perPage, page * perPage + perPage);

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', minHeight: '50vh' }}>
            <TableContainer sx={{ maxHeight: 600 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columnas.map((column) => (
                                <StyledTableCell
                                    style={{ minWidth: column.minWidth }}
                                    key={column.id}
                                >
                                    {column.label}
                                </StyledTableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {informe.informes.length > 0 ? (
                            rowsToDisplay.map((row) => (
                                <StyledTableRow key={row.idproyecto + '-' + row.anio}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.nombreProyecto}
                                    </StyledTableCell>
                                    <StyledTableCell align="left">{row.anio}</StyledTableCell>
                                    <StyledTableCell align="left">{DateToString(row.fechaEntrega)}</StyledTableCell>
                                    <StyledTableCell align="left">
                                        <Button variant="contained" color="primary" onClick={() => { IrAInforme(row.idproyecto) }}>
                                            Ir
                                        </Button>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))
                        ) : (
                            <StyledTableRow key="no-results">
                                <StyledTableCell component="th" scope="row">
                                    {'FAC-NUM-AÑO'}
                                </StyledTableCell>
                                <StyledTableCell align="left">{'No hubo resultados'}</StyledTableCell>
                                <StyledTableCell align="left"></StyledTableCell>
                                <StyledTableCell align="left">{format(new Date(), 'dd/MMM/yyyy')}</StyledTableCell>
                            </StyledTableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={rowsPerPage}
                component="div"
                count={informe.informes.length}
                rowsPerPage={perPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
};